import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { connect as connectFormik } from 'formik';
import { domainActions } from '../../store/domainStore';
import { finItem, unicornCountry, unicornFinValues, unicornAttribute, unicornAttributes, unicornFinValuesIfrs, unicornFinValuesIfrsOriginal, unicornFinStatementOrganizationValues } from '../../store/marketingListStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { selectDefaultStyles } from '../styling/selectDefaultStyles';
import { Translate, withLocalize } from 'react-localize-redux';
import BbInput from '../styling/bbInput';
import BbFormikCheckbox from "../styling/bbFormikCheckbox";
import FinValueRow from "./finValueRow";
import MarketingSection from "../marketingList/marketingSection";
import PlusIcon from "../../img/icons/Plus";
import SelectOption from './selectOption';
import PopupMultiSelectButton from '../common/popupMultiSelectButton';

import "./financialStatement.scss";

class FinancialStatement extends React.Component {
    state = {
        lastChange: new Date().getTime()
    }

    render() {
        return (
            <div className="fin-statements-root">
                <MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false} section="financial" errors={this.props.errors}>
                    <BbInput type='select-noformik' label={this.props.translate('Search.Marketing.FinancialStatementAvailability')}
                        placeholder={{ type: 'column' }}
                        options={this.getYearOptions()} formatOptionLabel={SelectOption}
                        onChange={(e) => this.props.formik.setFieldValue("financial.year", e.value)}
                        value={this.getYearOption(this.props.formik.values.financial.year)}
                        styles={selectDefaultStyles}
                    />
                    <div className="columns">
                        <div className="column" style={{ display: "flex", flexWrap: "wrap" }}>
                            <BbFormikCheckbox name="financial.checkLastOnly" label={this.props.translate("Search.Marketing.FinancialCheckLastOnly")} id="checkLastOnly" />
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column">
                            <MarketingSection name={this.props.translate(`Search.Marketing.FinancialStatementData${unicornCountry().toUpperCase()}`)} isOpen={true}>
                                {
                                    this.props.financialDomainsLoaded &&
                                    this.props.formik.values.financial.values.values.map((fv, i) => {
                                        return (
                                            <FinValueRow key={i} field="values" index={i} domain="fin-statement-values" placeholder={`Search.Marketing.FinancialStatementData${unicornCountry().toUpperCase()}`} />
                                        )
                                    })
                                }
                                <div className="icon-wrapper">
                                    <div className={`fin-button add ${this.props.formik.values.financial.values.values.length === 5 && "disabled"}`}>
                                        <PlusIcon onClick={() => this.addValueRow()} />
                                    </div>
                                </div>
                                {this.conditionsRow("values", false)}
                            </MarketingSection>
                        </div>
                    </div>
                    {unicornCountry() === 'sk' && <div><div className="columns">
                        <div className="column">
                            <MarketingSection name={this.props.translate(`Search.Marketing.FinancialStatementDataIfrs`)} isOpen={true}>
                                {
                                    this.props.financialDomainsLoaded &&
                                    this.props.formik.values.financial.valuesIfrs.values.map((fv, i) => {
                                        return (
                                            <FinValueRow key={i} field="valuesIfrs" index={i} domain="fin-statement-values-ifrs" placeholder={`Search.Marketing.FinancialStatementDataIfrs`} />
                                        )
                                    })
                                }
                                <div className="icon-wrapper">
                                    <div className={`fin-button add ${this.props.formik.values.financial.valuesIfrs.values.length === 5 && "disabled"}`}>
                                        <PlusIcon onClick={() => this.addValueIfrsRow()} />
                                    </div>
                                </div>
                                {this.conditionsRow("valuesIfrs", false)}
                            </MarketingSection>
                        </div>
                    </div>
                        <div className="columns">
                            <div className="column">
                                <MarketingSection name={this.props.translate(`Search.Marketing.FinancialStatementDataIfrsOriginal`)} isOpen={true}>
                                    {
                                        this.props.financialDomainsLoaded &&
                                        this.props.formik.values.financial.valuesIfrsOriginal.values.map((fv, i) => {
                                            return (
                                                <FinValueRow key={i} field="valuesIfrsOriginal" index={i} domain="fin-statement-values-ifrs-original" placeholder={`Search.Marketing.FinancialStatementDataIfrsOriginal`} />
                                            )
                                        })
                                    }
                                    <div className="icon-wrapper">
                                        <div className={`fin-button add ${this.props.formik.values.financial.valuesIfrsOriginal.values.length === 5 && "disabled"}`}>
                                            <PlusIcon onClick={() => this.addValueIfrsOriginalRow()} />
                                        </div>
                                    </div>
                                    {this.conditionsRow("valuesIfrsOriginal", false)}
                                </MarketingSection>
                            </div>
                        </div>
                        <div className="columns">
                        <div className="column">
                            <MarketingSection name={this.props.translate('Report.FinancialRatios.Organizations')} isOpen={true}>
                                {
                                    this.props.financialDomainsLoaded &&
                                    <>
                                    <BbInput type='custom' placeholder={{ type: 'column' }} label={this.props.translate('Report.FinancialRatios.Organizations')}
                                    style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "0" }}
                                    custom={
                                        <PopupMultiSelectButton
                                            title={this.props.translate('Report.FinancialRatios.Organizations')}
                                            data={'fin-statement-values-organizations-types'}
                                            name={'fin-statement-values-organizations-types'}
                                            popupSize='medium'
                                            selection={this.props.formik.values.financial.organizationsTypes}
                                            handleChange={(all, parent) =>  this.selectOrganizationType(all, parent)
                                             } />
                                    } />

                                
                                    {this.props.formik.values.financial.organizationsTypes.all && this.props.formik.values.financial.organizationsTypes.all.map((fv, i) => {
                                         return ( <>
                                            <MarketingSection name={fv.label} isOpen={true} style={{marginTop: "1em"}}>

                                                { this.props.formik.values.financial.organizationsValues.values[fv.value] &&
                                                    this.props.formik.values.financial.organizationsValues.values[fv.value].value.map((finVal, idx) => {
                                                        return <FinValueRow key={fv.value+-'-'+idx} typeName={fv.value} field="organizationsTypes" index={idx} domain={"fin-statement-values-organizations-values-" + fv.value} placeholder={this.props.translate('Report.FinancialRatios.Organizations')} />
                                                    })
                                                }

                                             <div className="icon-wrapper">
                                                <div className={`fin-button add ${this.props.formik.values.financial.organizationsTypes.length === 4 && "disabled"}`}>
                                                    <PlusIcon onClick={() => this.addOrganizationRow(fv.value.toString())} />
                                                </div>
                                            </div>
                                            </MarketingSection>

                                         </>
                                         )
                                     })
                                    }
                                    </>
                                }
 
                                {this.conditionsRow("organizationsTypes", false)}
                            </MarketingSection>
                        </div>
                    </div>
                </div>
                        
                    }

                    <div className="columns">
                        <div className="column">
                            <MarketingSection name={this.props.translate('Report.FinancialRatios.RatiosSection')} isOpen={true}>
                                {
                                    this.props.financialDomainsLoaded &&
                                    this.props.formik.values.financial.ratios.values.map((fv, i) => {
                                        return (
                                            <FinValueRow key={i} field="ratios" index={i} domain="fin-statement-ratios" placeholder={"Report.FinancialRatios.RatiosSection"} />
                                        )
                                    })
                                }
                                <div className="icon-wrapper">
                                    <div className={`fin-button add ${this.props.formik.values.financial.ratios.values.length === 5 && "disabled"}`}>
                                        <PlusIcon onClick={() => this.addRatioRow()} />
                                    </div>
                                </div>
                                {this.conditionsRow("ratios", false)}
                            </MarketingSection>
                        </div>
                    </div>
                </MarketingSection >
            </div>
        );
    }

    selectOrganizationType = (all, parent) => 
    {
        this.props.formik.setFieldValue(`financial.organizationsTypes`, { all: all, parent: parent, checked: true, condition: this.props.formik.values.financial.organizationsTypes.condition });   

    }

    componentDidMount() {
        this.ensureDomainData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeLanguage.code !== prevProps.activeLanguage.code)
            this.ensureDomainData();
    }

    ensureDomainData() {
        this.props.ensureDomainData('fin-statement-values', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinValues() });
        if (unicornCountry() === 'sk') {
            this.props.ensureDomainData('fin-statement-values-ifrs', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinValuesIfrs() });
            this.props.ensureDomainData('fin-statement-values-ifrs-original', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinValuesIfrsOriginal() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-sasp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-v', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-vh', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
            this.props.ensureDomainData('fin-statement-values-organizations-values-vp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });

            this.props.ensureDomainData('fin-statement-values-organizations-types', { marketAttribute: unicornAttribute()});
        }
        this.props.ensureDomainData('fin-statement-ratios', { marketAttributes: unicornAttributes() });
    }

    addValueRow = () => {
        if (this.props.formik.values.financial.values.values.length < 5) {
            this.props.formik.values.financial.values.values.push(finItem);
            this.setState({ lastChange: new Date().getTime() })
        }
    }

    addValueIfrsRow = () => {
        if (this.props.formik.values.financial.valuesIfrs.values.length < 5) {
            this.props.formik.values.financial.valuesIfrs.values.push(finItem);
            this.setState({ lastChange: new Date().getTime() })
        }
    }

    addValueIfrsOriginalRow = () => {
        if (this.props.formik.values.financial.valuesIfrsOriginal.values.length < 5) {
            this.props.formik.values.financial.valuesIfrsOriginal.values.push(finItem);
            this.setState({ lastChange: new Date().getTime() })
        }
    }

    addRatioRow = () => {
        if (this.props.formik.values.financial.ratios.values.length < 5) {
            this.props.formik.values.financial.ratios.values.push(finItem);
            this.setState({ lastChange: new Date().getTime() })
        }
    }

    addOrganizationRow = (type) => {
            //Check whether we have prepared array
            if (isNullOrUndefined(this.props.formik.values.financial.organizationsValues.values[type])) {
                let data = this.props.formik.values.financial.organizationsValues.values;
                data[type] = {value: []};
                data[type].value.push(finItem);
                this.props.formik.setFieldValue(`financial.organizationsValues.values`, data);
            } else {
                this.props.formik.values.financial.organizationsValues.values[type].value.push(finItem);
            }
            this.setState({ lastChange: new Date().getTime() })
        
    }


    getYearOption(year) {
        if (year === 1900)
            return { value: 1900, key: 1900, label: this.props.translate("Search.Marketing.FinancialStatementAvailability.Any") }
        else if (isNullOrUndefined(year) || year === "")
            return { value: "", key: "none", label: "" };
        else
            return { key: year, value: year, label: `${this.props.translate("Search.Marketing.FinancialStatementAvailability.NotOlderThan")} ${year}` };
    }

    getYearOptions() {
        let options = [];
        options.push(this.getYearOption(""));

        const loopMax = new Date().getFullYear() - 5;
        for (let i = new Date().getFullYear() - 1; i >= loopMax; i--)
            options.push(this.getYearOption(i));

        options.push(this.getYearOption(1900));
        return options;
    }

    conditionsRow = (field, includeCurrency = true) => {
        return (<>
            <BbInput type='radio' label={this.props.translate('Search.Marketing.ConditionType')} placeholder={{ type: 'column' }}
                options={[
                    { value: 'AND', label: 'Search.Common.ConditionAnd' },
                    { value: 'OR', label: 'Search.Common.ConditionOr' }
                ]} idFormat={(val) => `$radio-financial-${field}-condition-${val}`}
                checkedValue={this.props.formik.values.financial[field].condition}
                callback={(val) => this.props.formik.setFieldValue(`financial.${field}.condition`, val)}
            />
            {includeCurrency && <div className="field bb-field">
                <div className="columns">
                    <div className="column bb-input-label-column is-one-third">
                        <div className="vertically-centered">
                            <span> <Translate id="Search.Marketing.FinancialStatementCurrency" /></span>
                        </div>
                    </div>
                    <div className="column is-8">
                        <CurrencySelector formik={this.props.formik} />
                    </div>
                </div>
            </div>}
        </>);
    }
}

class CurrencySelector extends React.Component {
    render() {
        return (
            <div className="currency-selector">
                <span data-active={this.props.formik.values.financial.values.currency === "CZK"}
                    onClick={() => this.props.formik.setFieldValue(`financial.values.currency`, 'CZK')}>CZK
                </span>
                <span data-active={this.props.formik.values.financial.values.currency === "EUR"}
                    onClick={() => this.props.formik.setFieldValue(`financial.values.currency`, 'EUR')}>EUR
                </span>
            </div>
        )
    }
}

export default withLocalize(connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch),
)(FinancialStatement)));